export const capitaliseFirstLetter = (inputString: string): string => {
  if (inputString.length === 0) {
    return inputString; // Return the string as is if it's empty
  }

  return inputString.charAt(0).toLowerCase() + inputString.slice(1);
};
